import React, { useState } from "react";
import authService from "../services/authService";


const ConfirmOTP = ({ phoneNumber, onLogin }) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await authService.confirmChallenge(phoneNumber, otp, "123456789012", null);
      const { accessToken, refreshToken } = response.data;
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      onLogin();
    } catch (error) {
        console.log(error);
      setError("Invalid OTP. Please try again.");
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card p-4 shadow-sm" style={{ width: "100%", maxWidth: "400px" }}>
        <h2 className="text-center mb-4">Подтвердить</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group mb-3">
            <label htmlFor="otpInput"></label>
            <input
              type="text"
              id="otpInput"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="form-control"
              placeholder="Код смс"
            />
            {error && <div className="text-danger mt-2">{error}</div>}
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Отправить
          </button>
        </form>
      </div>
    </div>
  );
};

export default ConfirmOTP;
